import React from 'react';
import propTypes from 'prop-types';

export default function ChevronIcon({ className }) {
  return (
    <svg
      className={className}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    >
      <polyline points='6 9 12 15 18 9' />
    </svg>
  );
}

ChevronIcon.propTypes = {
  className: propTypes.string.isRequired
};
